import { useMemo } from 'react';
class DefaultSearchFilter {
    searchableFields = ['firstName', 'lastName', 'email', 'employeeCode'];
    matches(beneficiary, searchTerm) {
        const trimmedSearchTerm = searchTerm.trim();
        if (trimmedSearchTerm === '')
            return true;
        const lowerSearchTerm = trimmedSearchTerm.toLowerCase();
        const fieldMatch = this.searchableFields.some(field => {
            const value = beneficiary[field];
            return value?.toLowerCase().includes(lowerSearchTerm) ?? false;
        });
        if (fieldMatch)
            return true;
        const fullName = `${beneficiary.firstName} ${beneficiary.lastName}`.toLowerCase();
        return fullName.includes(lowerSearchTerm);
    }
}
const filterBeneficiaries = (beneficiaries, searchTerm, showNewOnly, searchFilter = new DefaultSearchFilter()) => {
    return beneficiaries.filter(beneficiary => {
        const searchMatch = searchFilter.matches(beneficiary, searchTerm);
        const newEmployeeMatch = !showNewOnly || beneficiary.isNew;
        return searchMatch && newEmployeeMatch;
    });
};
const countNewEmployees = (beneficiaries) => {
    return beneficiaries.filter(b => b.isNew).length;
};
export function useBeneficiaryFilters({ beneficiaries, searchTerm, showNewOnly, }) {
    const filteredBeneficiaries = useMemo(() => {
        return filterBeneficiaries(beneficiaries, searchTerm, showNewOnly);
    }, [beneficiaries, searchTerm, showNewOnly]);
    const newEmployeesCount = useMemo(() => {
        return countNewEmployees(beneficiaries);
    }, [beneficiaries]);
    return {
        filteredBeneficiaries,
        newEmployeesCount,
    };
}
